import { PopoverBody as ChakraPopoverBody } from "@chakra-ui/react";

export const PopoverBody = ChakraPopoverBody;
